import { useRef, useState } from "react";
import { Button, Form, InputGroup, Stack } from "react-bootstrap";
import { LockFill, PersonFill } from "react-bootstrap-icons";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/Auth";
import { ReactComponent as Logo } from "../../assets/LogoSquareWhite.svg";

export default function LoginForm() {
    const { onLogin } = useAuth();
    const [error, setError] = useState(null);
    const [logggingIn, setLogggingIn] = useState(false);
    const formRef = useRef();
    const [capsLockOn, setCapsLockOn] = useState(false);
    const location = useLocation();

    const handleKeyUp = e => {
        const capsLockIsOn = e.getModifierState("CapsLock");
        setCapsLockOn(capsLockIsOn);
    };

    const handleSubmit = async event => {
        event.preventDefault();
        setLogggingIn(true);
        const data = new FormData(formRef.current);
        data.append("superuser", "true");
        setError(await onLogin(data, location.state?.from?.pathname));
        setLogggingIn(false);
    };

    return (
        <>
            <Form onSubmit={handleSubmit} gap={2} ref={formRef} className="mb-3 w-100">
                <Stack
                    direction="horizontal"
                    gap={2}
                    className="mb-3 d-flex flex-row align-items-xl-center align-items-start justify-content-center justify-content-xl-start">
                    <Logo className="d-none d-xl-block logo-fixed-size" />
                    <div className="ms-lg-2 text-center text-xl-start">
                        <h1 className="display-5 fs-xs-1 fw-bold text-white m-0">RadioAnalyzer</h1>
                        <h1 className="display-5 fs-xs-1 fw-bold text-white m-0">PRO Tool</h1>
                    </div>
                </Stack>
                <InputGroup className="my-2">
                    <InputGroup.Text className="text-blue bg-beige text-ra-dark-blue fs-4 p-2">
                        <PersonFill />
                    </InputGroup.Text>
                    <Form.Control className=" rounded-end" size="lg" required type="text" name="username" placeholder="Username" />
                </InputGroup>
                <InputGroup className="mb-4">
                    <InputGroup.Text className="text-blue bg-beige text-ra-dark-blue fs-4 p-2">
                        <LockFill />
                    </InputGroup.Text>
                    <Form.Control className="rounded-end" size="lg" required type="password" name="password" placeholder="Password" onKeyUp={handleKeyUp} />
                </InputGroup>
                {capsLockOn && <div className="text-warning mb-2">Caps Lock is on. Passwords are case-sensitive.</div>}

                <Stack direction="horizontal" gap={3} className=" flex-wrap-reverse">
                    <NavLink
                        to={"forgot_password"}
                        className="text-light link-underline-light link-underline-opacity-0 link-underline-opacity-75-hover col-12 text-center col-xl-auto">
                        Forgot password?
                    </NavLink>
                    <Button
                        className="btn-ra-yellow text-uppercase fw-bold px-5 ms-auto col-12 fs-5 col-xl-auto"
                        size="sm"
                        disabled={logggingIn}
                        type={"submit"}>
                        Login
                    </Button>
                </Stack>
                <div className=" position-relative my-2 text-center text-xl-start">
                    <label className="text-warning login-error-message">{error}</label>
                </div>
            </Form>
            <Button onClick={() => window.open("https://musictest.pro/", "_blank")} size="sm" className=" btn-ra-yellow d-xl-none mt-auto mb-3 mb-sm-0">
                Looking for Music Test by RA? <strong>Login here</strong>
            </Button>
        </>
    );
}
